import React from "react";
import Button from "../../../../shared/button/button";

import indication from "../../../../img/advanced-management/indication.svg";
import AdvancedManagementInfoStep from "../template/AdvancedManagementInfoStep";

const AdvancedManagementNoBoundsFound = ({ nextStep } = props) => {
	return (
		<AdvancedManagementInfoStep
			dataImg={indication}
			dataText={
				<React.Fragment>
					<strong>Você não tem participantes com contas vinculadas.</strong>
					<br />
					Indique um participante clicando no botão abaixo.
				</React.Fragment>
			}
		>
			<Button className="btn-secondary-lg" onClick={() => nextStep(1)}>
				Indicar agora
			</Button>
		</AdvancedManagementInfoStep>
	);
};

export default AdvancedManagementNoBoundsFound;
